import {
  createContext,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useMemo,
} from 'react';

type PageContextValue = {
  editing: boolean;
  sorting: boolean;
  setEditing: Dispatch<SetStateAction<boolean>>;
  setSorting: Dispatch<SetStateAction<boolean>>;
};

const PageContext = createContext<PageContextValue | undefined>(undefined);

export function usePageContext() {
  return useContext(PageContext);
}

type PageContextProviderProps = PropsWithChildren<PageContextValue>;

export function PageContextProvider(props: PageContextProviderProps) {
  const { children, editing, sorting, setEditing, setSorting } = props;

  const value = useMemo(
    () => ({
      editing,
      sorting,
      setEditing,
      setSorting,
    }),
    [editing, sorting, setEditing, setSorting],
  );

  return <PageContext.Provider value={value}>{children}</PageContext.Provider>;
}
